var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FavoriteToggle } from "@react-components/ui/FavoriteToggle/FavoriteToggle";
var FavoriteCard = function (_a) {
    var id = _a.id, heading = _a.heading, manchet = _a.manchet, url = _a.url;
    return (_jsxs("div", __assign({ className: "card card--favorite" }, { children: [url && (_jsx("a", __assign({ href: url, className: "card__block-link" }, { children: heading && (_jsx("span", { className: "sr-only", dangerouslySetInnerHTML: { __html: heading } }, void 0)) }), void 0)), id && (_jsx("div", __assign({ className: "card__favorite-wrap" }, { children: _jsx(FavoriteToggle, { id: id.toString() }, void 0) }), void 0)), _jsxs("div", __assign({ className: "card__content" }, { children: [heading && (_jsx("h3", { className: "card__heading", dangerouslySetInnerHTML: { __html: heading } }, void 0)), manchet && _jsx("p", __assign({ className: "card__lead" }, { children: manchet }), void 0)] }), void 0)] }), void 0));
};
export { FavoriteCard };
